import types from './types';

const setProperty = (key, value) => {
    return {
        type: types.SET_PROPERTY,
        key: key,
        value: value
    }
}

const setUpSignalR = (token) => {
    return {
        type: types.SET_UP_SIGNALR,
        token: token
    }
}

const openSnack = (text, variant) => {
    return {
        type: types.OPEN_SNACK,
        text: text,
        variant: variant
    }
};
const closeSnack = () => {
    return {
        type: types.CLOSE_SNACK
    }
};

const openAuthDialog = (formType) => {
    return {
        type: types.OPEN_AUTH_DIALOG,
        formType: formType
    }
}
const setAuthDialogFormType = (formType) => {
    return {
        type: types.SET_AUTH_DIALOG_FORM_TYPE,
        formType: formType
    }
};
const closeAuthDialog = () => {
    return {
        type: types.CLOSE_AUTH_DIALOG
    }
}
const startAuthDialogRequest = () => {
    return {
        type: types.START_AUTH_DIALOG_REQUEST
    }
};
const stopAuthDialogRequest = () => {
    return {
        type: types.STOP_AUTH_DIALOG_REQUEST
    }
};
const completeLogin = (success, message) => {
    return {
        type: types.COMPLETE_LOGIN,
        success: success,
        message: message
    }
};
const completeSignUp = (success, message) => {
    return {
        type: types.COMPLETE_SIGN_UP,
        success: success,
        message: message
    }
};
const completePasswordRecoverRequest = (success, message) => {
    return {
        type: types.COMPLETE_PASSWORD_RECOVER_REQUEST,
        success: success,
        message: message
    }
};

const setRefreshMethod = (refreshMethod) => {
    return {
        type: types.SET_REFRESH_METHOD,
        refreshMethod: refreshMethod,
    }
};

const setAccountDetails = (details) => {
    return {
        type: types.SET_ACCOUNT_DETAILS,
        details: details,
    }
};
const setGettingAccountDetails = (isGetting) => {
    return {
        type: types.SET_GETTING_ACCOUNT_DETAILS,
        isGetting: isGetting,
    }
};

const showInformationDialog = (open, title, text, buttonText) => {
    return {
        type: types.SHOW_INFORMATION_DIALOG,
        title,
        open,
        text,
        buttonText
    }
}

export default {
    setProperty,
    setUpSignalR,
    openSnack,
    closeSnack,
    openAuthDialog,
    closeAuthDialog,
    setAuthDialogFormType,
    startAuthDialogRequest,
    stopAuthDialogRequest,
    completeLogin,
    completeSignUp,
    completePasswordRecoverRequest,
    setRefreshMethod,
    setAccountDetails,
    setGettingAccountDetails,
    showInformationDialog
}